import { XyoWorldBase } from '../../../Base'
import { XyoWorldGeotokensWrapper } from '../../../EthersClients'
import { BaseJsonObject } from '../../../models'
import { Quadkey } from '../../../Quadkey'
import { GeotokenJsonObject, XyoWorldGeotoken } from '../Geotoken'

export interface GeotokenFactoryJsonObject extends BaseJsonObject {
  geotokens: GeotokenJsonObject[]
}

export class XyoWorldGeotokenFactory extends XyoWorldBase<GeotokenFactoryJsonObject> {
  public wrapper: XyoWorldGeotokensWrapper

  private map = new Map<string, XyoWorldGeotoken>()

  constructor(wrapper: XyoWorldGeotokensWrapper) {
    super()
    this.wrapper = wrapper
  }

  public clear() {
    this.map.clear()
    return this
  }

  public async fetch(quadkey: Quadkey) {
    const result = this.get(quadkey)
    await result.refresh()
    return result
  }

  public get(quadkey: Quadkey, jsonObject?: GeotokenJsonObject): XyoWorldGeotoken {
    let result = this.map.get(quadkey.toHex())
    if (!result) {
      result = new XyoWorldGeotoken(quadkey, this.wrapper, jsonObject)
      this.map.set(quadkey.toHex(), result)
    } else {
      result.loadJsonObject(jsonObject)
    }
    return result
  }

  public getAll() {
    const result: XyoWorldGeotoken[] = []
    for (const value of this.map.values()) {
      result.push(value)
    }
    return result
  }

  loadJsonObject(jsonObject?: GeotokenFactoryJsonObject) {
    if (jsonObject) {
      for (const geotokenJsonObject of jsonObject.geotokens) {
        const quadkey = Quadkey.fromBase4String(geotokenJsonObject.quadkey)
        if (quadkey) {
          this.get(quadkey, geotokenJsonObject)
        }
      }
    }
    return this
  }

  toJsonObject(): GeotokenFactoryJsonObject {
    const geotokens: GeotokenJsonObject[] = []
    this.map.forEach((value) => {
      geotokens.push(value.toJsonObject())
    })
    return { geotokens }
  }

  public async update() {
    const promises: Promise<XyoWorldGeotoken>[] = []
    for (const pair of this.map) {
      promises.push(pair[1].update())
    }
    await Promise.all(promises)
    return this
  }
}
